// extracted by mini-css-extract-plugin
export default {"gallerySection":"Gallery_gallerySection__kefN6","grid":"Gallery_grid__D5PI+","card":"Gallery_card__ulEdL","img":"Gallery_img__MiTaN","caption":"Gallery_caption__dmRpx"};